import * as React from 'react';
import { MenuItemVisibleContext } from '../src/MenuItemVisibleProvider.js';

function useMenuItemVisible() {
    const context = React.useContext(MenuItemVisibleContext);
    if (!context || Object.keys(context).length === 0)
        throw new Error('useMenuItemVisible hook must be inside MenuItemVisibleProvider');
    const { item, setItem } = context;
    return [item, setItem];
}

export { useMenuItemVisible };
//# sourceMappingURL=useMenuItemVisible.js.map
